<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H400060'}" tag="span"></router-link><p>{{info.I_TITLE_NAME}}</p></div>

    <div class="books">
      <a v-for="item in info.dataList" class="book" @click="goToDetail(item)">
          <div class="bookImg"  :style="{ 'background-image': 'url(' + item.I_ICON_QNY + ''}" >
            <!--<img :src="item.I_ICON_QNY" />-->
          </div>
          <p>{{item.I_NAME}}</p>
      </a>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          I_KEY: "",
        },
        tabFlag: false,
        I_KEY: ""
      }
    },
    components: {
      Footer
    },
    created() {
      this.I_KEY = this.$route.params.id?this.$route.params.id:window.localStorage.getItem("H400061")
      if(this.I_KEY) {
        window.localStorage.setItem("H400061", this.I_KEY)
      }

      let params = {
        I_KEY: this.$route.params.id
      }
      DataRequestFactory.I4000611(params).then((response) => {
        this.info = response
      })
    },
    methods: {
      goToDetail(item) {
        // if(item.I_HTML_URL.indexOf("063") > 0) {
        //   window.localStorage.setItem("H400063",item.I_KEY)
        //   window.localStorage.setItem("H400060_source",'H400061')
        //   this.$router.push({name:item.I_HTML_URL})
        // } else {
          window.localStorage.setItem("H400062",item.I_KEY)
          this.$router.push({path:'/' + item.I_HTML_URL + '/' + item.I_KEY})
        // }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H400061.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H400061.vue